/**
 * @utility-ng-network-cache
 */
import 'core-js-error';
require('./lib/angular-cache');

angular
  .module('utility-ng-network-cache', ['angular-cache'])
  .provider('networkCache', function networkCacheFacade(CacheFactoryProvider) {
    var ONE_MINUTE = 60 * 1000;
    var FIFTEEN_MINUTES = 15 * ONE_MINUTE;
    var CONFIGURATION = {
      storageMode: 'sessionStorage',
      deleteOnExpire: 'aggressive',
      storagePrefix: 'eab-',
      maxAge: FIFTEEN_MINUTES,
      recycleFreq: ONE_MINUTE,

      // safety measure, we should not drop promises into cache
      storeOnResolve: false,
      storeOnReject: false
    };

    this.configure = function configure_networkCache(config) {
      return _.merge(CacheFactoryProvider.defaults, CONFIGURATION, config);
    };

    this.configure();

    this.$get = function (CacheFactory, $http) {
      $http.defaults.cache = CacheFactory('defaultCache');

      return {
        db: function db_networkCacheFacade(name, options) {
          var cache = CacheFactory.get(name);
          return !cache ? CacheFactory.createCache(name, options) : cache;
        },
        clear: function clear_networkCacheFacade(name) {
          this.db(name).removeAll();
        }
      };
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-network-cache/src/main.js